import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class PendingWriteService {
  count = 0;
}

@Injectable()
export class PendingWriteInterceptor implements HttpInterceptor {
  constructor(private readonly writes: PendingWriteService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Legacy PT4 sends these commands using GET, including when optimistic
    // planning is disabled and there is no calculation operation to track them.
    const legacyCommand = request.method === 'GET' &&
      /\/transportorders\/(send-to-haulier|resendid)\/?$/i.test(request.url.split(/[?#]/)[0]);
    if (['POST', 'PUT', 'PATCH', 'DELETE'].indexOf(request.method) === -1 && !legacyCommand) {
      return next.handle(request);
    }
    this.writes.count++;
    return next.handle(request).pipe(finalize(() => this.writes.count--));
  }
}
